import * as React from "react"
import type { SVGProps } from "react"
const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7.82 13.3H19a1 1 0 0 0 .71-.3 1 1 0 0 0 .29-.7 1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.29H7.82l4.9-4.9q.3-.3.29-.7a1 1 0 0 0-.31-.7q-.3-.27-.7-.28a1 1 0 0 0-.7.28l-6.6 6.6a1 1 0 0 0-.22.33 1 1 0 0 0-.06.37q0 .2.06.38a1 1 0 0 0 .21.32l6.6 6.6a1 1 0 0 0 .7.28q.4 0 .7-.28.3-.3.3-.71 0-.42-.3-.71z" />
  </svg>
)
export default SvgArrowLeft
